module.exports = __webpack_public_path__ + "static/media/related-service-icon.717531c5.svg";